<template>
	<div>
		<el-card shadow="never">
			<div slot="header" class="clearfix">
				<h4>基本信息</h4>
			</div>
			<el-descriptions title="" :column="1" border>
				<el-descriptions-item label="课程名称">{{detailObject.course_name}}</el-descriptions-item>
				<el-descriptions-item label="订单编号">{{detailObject.order_id}}</el-descriptions-item>
				<el-descriptions-item label="购买用户">{{detailObject.user_name}}</el-descriptions-item>
				<el-descriptions-item label="用户会员等级">{{detailObject.member_name}}</el-descriptions-item>
				<el-descriptions-item label="购买章节数">{{detailObject.detail.length}}</el-descriptions-item>
			</el-descriptions>
		</el-card>
		<el-card shadow="never" style="margin-top: 10px;">
			<div slot="header" class="clearfix">
				<h4>订单信息</h4>
			</div>
			<el-table show-summary :summary-method="getSumColumn" :data="detailObject.detail" border class="table-wrap"
				:header-cell-style="{background:'#eef1f6',color:'#606266'}" style="width: 100%">
				<el-table-column prop="name" label="章节名称" align="center">
				</el-table-column>
				<el-table-column prop="score" label="章节积分" align="center">
				</el-table-column>
				<el-table-column prop="yhscore" label="优惠积分" align="center">
					<template slot-scope="scope">
						{{scope.row.score-scope.row.score_cost}}
					</template>
				</el-table-column>
				<el-table-column prop="score_cost" label="实际支付" align="center">
				</el-table-column>
			</el-table>
		</el-card>
		<el-card shadow="never" style="margin-top: 10px;" class="flex flex-c">
			<el-button type="primary" style="width: 200px;" plain @click="goBack">返回</el-button>
		</el-card>


	</div>
</template>

<script>
	import {
		imgDomain
	} from '@/configs/env';
	import operations from "@/mixins/operations";
	import CommonPagination from "@/components/CommonPagination";
	import {
		getCourseOrderDetail,
	} from "@/api/orders"
	import {
		mapState
	} from "vuex";

	export default {
		name: "userDetail",
		mixins: [operations],
		data() {
			return {
				activeTab: 'first',
				imgDomain,
				total: 0,
				page_size: 9,
				page_index: 1,
				doubaoList: [],
				num: 1,
				detailObject: {
					detail: []
				},
				detailUserId: '',
				selectedTabIndex: "all",
				activeName: '1',
				user_uuid: '',
				total1: 0,
				page_index1: 1,
				page_size1: 9,
				hisLists: [],
			};
		},
		components: {
			CommonPagination,
		},
		async mounted() {
			const uuid = this.$route.query.uuid
			this.user_uuid = uuid
			if (uuid) {
				this.getCourseOrderDetail(uuid);
			}
		},
		methods: {
			getSumColumn(param) {
				const {
					columns,
					data
				} = param;
				const sums = [];
				columns.forEach((column, index) => {
					// 第一列通常显示“合计”字样
					if (index === 0) {
						sums[index] = '合计';
						return;
					}

					// 处理“优惠积分”列，该列的值由模板中的表达式计算得出
					if (column.property === 'yhscore') {
						// 手动计算每一行“优惠积分”的值并求和
						const total = data.reduce((sum, item) => {
							// 复写模板中的计算逻辑: scope.row.score - scope.row.score_cost
							const value = Number(item.score) - Number(item.score_cost);
							// 确保计算结果是有效数字后再累加
							if (!isNaN(value)) {
								return sum + value;
							}
							return sum;
						}, 0);
						sums[index] = total;
						// 可选：为合计值添加单位或格式化
						// sums[index] = total + ' 积分';
					} else {
						// 对于其他有直接对应数据属性的列（如score, score_cost），可以使用常规的求和方式
						const values = data.map(item => Number(item[column.property]));
						if (!values.every(value => isNaN(value))) {
							sums[index] = values.reduce((prev, curr) => {
								const value = Number(curr);
								if (!isNaN(value)) {
									return prev + curr;
								}
								return prev;
							}, 0);
						} else {
							// 如果该列无法求和（如“章节名称”），可以显示占位符
							sums[index] = '——';
						}
					}
				});
				return sums;
			},

			handlePageChange(page) {
				this.page_index = page
				this.getDoubao()
			},
			handlePageChange1(page) {
				this.page_index1 = page
				this.getAiApplicationHistoryList()
			},
			handleClick(tab, event) {
				if (tab.name == 'second') {
					this.getAiApplicationHistoryList()
				}
				if (tab.name == 'first') {
					this.getDoubao()
				}
			},
			async getDoubao() {
				let postData = {
					page_size: this.page_size,
					page_index: this.page_index,
					user_uuid: this.user_uuid
				};
				const {
					status,
					data
				} = await getDoubao(postData);
				if (status !== 200) return;
				this.doubaoList = data.result.data;
				this.total = data.result.total;
			},
			async getAiApplicationHistoryList() {
				let postData = {
					page_size: this.page_size1,
					page_index: this.page_index1,
					user_uuid: this.user_uuid
				};
				const {
					status,
					data
				} = await getAiApplicationHistoryList(postData);
				if (status !== 200) return;
				this.hisLists = data.result.data;
				this.total1 = data.result.total;
			},
			goBack() {
				this.$router.go(-1)
			},
			async getCourseOrderDetail(uuid) {
				const {
					data,
					status
				} = await getCourseOrderDetail({
					uuid: uuid
				});
				if (status === 200) {
					this.detailObject = data.result;
				}
			},
			handleClickBack() {
				this.$router.back(-1);
			},
			async disableUser() {
				let postData = {
					user_id: this.detailObject.user_id
				}
				const {
					status,
					data
				} = await disableUser(postData);
				if (status !== 200) return;
				await this.getCourseOrderDetail(this.detailObject.user_id);
			},

			async ableUser() {
				let postData = {
					user_id: this.detailObject.user_id
				}
				const {
					status,
					data
				} = await ableUser(postData);
				if (status !== 200) return;
				await this.getCourseOrderDetail(this.detailObject.user_id);
			},

		}
	};
</script>

<style lang="less" scoped>
	::v-deep .el-descriptions-item__label {
		width: 15% !important;
	}

	::v-deep .el-descriptions-item__cell {
		color: #000;
	}

	.titles {
		color: #000;
		font-size: 20px;
	}

	.subtitle {
		color: #000;
		font-size: 18px;
		margin-bottom: 30px;
	}

	.el-icon-back {
		font-size: 22px !important;
		cursor: pointer;
	}

	.leftbg {
		display: flex;
		align-items: center;
	}

	.ava {
		width: 88px;
		height: 88px;
		border-radius: 50%;
		margin-right: 30px;
	}

	.lefttitle {
		font-size: 16px;
		color: #999;
		margin-bottom: 20px;
	}

	.leftval {
		margin-bottom: 20px;
		font-size: 16px;
		color: #000;
	}

	.imgsList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

		.imgItem {
			width: 32%;
			margin-right: 20px;
			margin-bottom: 20px;
		}
	}

	.operation-item {
		color: #409EFF;
		cursor: pointer;
		justify-content: center;
	}
</style>